import Chart from 'chart.js'
import memorieLogo from "./images/apps/memorie.png"
import smartyLogo from "./images/apps/smarty.png"
import galiniLogo from "./images/apps/galini.png"
import trufocusLogo from "./images/apps/trufocus.png"
import moment from "moment"

export const EVENT_OPEN_ACCOUNT_SELECTION_MODAL = 'EVENT_OPEN_ACCOUNT_SELECTION_MODAL'
export const EVENT_COGOLAND_SESSION_RESCEDULED = 'EVENT_COGOLAND_SESSION_RESCEDULED'

export const EVENT_USER_SAVED = 'EVENT_USER_SAVED'
export const EVENT_USER_COMMENT_CREATED = 'EVENT_USER_COMMENT_CREATED'
export const EVENT_ALL_LEVEL_UNLOCKED = 'EVENT_ALL_LEVEL_UNLOCKED'
export const EVENT_USER_CREATED = 'EVENT_USER_CREATED'
export const EVENT_USER_UPDATED = 'EVENT_USER_UPDATED'

export const EVENT_ENTERPRISE_ACCOUNT_CREATED = 'EVENT_ENTERPRISE_ACCOUNT_CREATED'
export const EVENT_ENTERPRISE_ACCOUNT_UPDATED = 'EVENT_ENTERPRISE_ACCOUNT_UPDATED'

export const EVENT_CONSUMER_ACCOUNT_CREATED = 'EVENT_CONSUMER_ACCOUNT_CREATED'
export const EVENT_CONSUMER_ACCOUNT_UPDATED = 'EVENT_CONSUMER_ACCOUNT_UPDATED'

export const PASSWORD_MIN_LENGTH = 8
export const START_DATE_OF_ALL_TIME = '2015-01-01'

export const ACTION_LOCALE_CHANGE = 'ACTION_LOCALE_CHANGE'
export const ACTION_ADMIN_COMMON_SETTING_CHANGE = 'ACTION_ADMIN_COMMON_SETTING_CHANGE'
export const ACTION_ENTERPRISE_COMMON_SETTING_CHANGE = 'ACTION_ENTERPRISE_COMMON_SETTING_CHANGE'

export const ACTION_USER_LOGGING_IN = 'ACTION_USER_LOGGING_IN'
export const ACTION_USER_LOGGING_IN_ERROR = 'ACTION_USER_LOGGING_IN_ERROR'
export const ACTION_USER_LOGGED_IN = 'ACTION_USER_LOGGED_IN'
export const ACTION_USER_LOGGED_OUT = 'ACTION_USER_LOGGED_OUT'

export const ACTION_GAME_RESULT_LOADING_ERROR = 'ACTION_GAME_RESULT_LOADING_ERROR'
export const ACTION_GAME_RESULT_LOADING = 'ACTION_GAME_RESULT_LOADING'
export const ACTION_GAME_RESULT_LOADED = 'ACTION_GAME_RESULT_LOADED'

export const ACTION_QUERY_SURVEY_ERROR = 'ACTION_QUERY_SURVEY_ERROR'
export const ACTION_QUERY_SURVEY_LOADING = 'ACTION_QUERY_SURVEY_LOADING'
export const ACTION_QUERY_SURVEY_LOADED = 'ACTION_QUERY_SURVEY_LOADED'

export const ACTION_SAVE_SURVEY_ERROR = 'ACTION_SAVE_SURVEY_ERROR'
export const ACTION_SAVE_SURVEY_LOADING = 'ACTION_SAVE_SURVEY_LOADING'
export const ACTION_SAVE_SURVEY_LOADED = 'ACTION_SAVE_SURVEY_LOADED'

export const ACTION_SAVE_SURVEY_ANSWER_ERROR = 'ACTION_SAVE_SURVEY_ANSWER_ERROR'
export const ACTION_SAVE_SURVEY_ANSWER_LOADING = 'ACTION_SAVE_SURVEY_ANSWER_LOADING'
export const ACTION_SAVE_SURVEY_ANSWER_LOADED = 'ACTION_SAVE_SURVEY_ANSWER_LOADED'

export const ACTION_GAME_RESULT_AGGREGATION_LOADING_ERROR = 'ACTION_GAME_RESULT_AGGREGATION_LOADING_ERROR'
export const ACTION_GAME_RESULT_AGGREGATION_LOADING = 'ACTION_GAME_RESULT_AGGREGATION_LOADING'
export const ACTION_GAME_RESULT_AGGREGATION_LOADED = 'ACTION_GAME_RESULT_AGGREGATION_LOADED'

export const ACTION_GAME_RESULT_AGGREGATION_BY_USER_LOADING_ERROR = 'ACTION_GAME_RESULT_AGGREGATION_BY_USER_LOADING_ERROR'
export const ACTION_GAME_RESULT_AGGREGATION_BY_USER_LOADING = 'ACTION_GAME_RESULT_AGGREGATION_BY_USER_LOADING'
export const ACTION_GAME_RESULT_AGGREGATION_BY_USER_LOADED = 'ACTION_GAME_RESULT_AGGREGATION_BY_USER_LOADED'

export const ACTION_TRUFOCUS_SESSION_ERROR = 'ACTION_TRUFOCUS_SESSION_ERROR'
export const ACTION_TRUFOCUS_SESSION_LOADING = 'ACTION_TRUFOCUS_SESSION_LOADING'
export const ACTION_TRUFOCUS_SESSION_LOADED = 'ACTION_TRUFOCUS_SESSION_LOADED'

export const ACTION_TRUFOCUS_SESSION_BY_USER_ERROR = 'ACTION_TRUFOCUS_SESSION_BY_USER_ERROR'
export const ACTION_TRUFOCUS_SESSION_BY_USER_LOADING = 'ACTION_TRUFOCUS_SESSION_BY_USER_LOADING'
export const ACTION_TRUFOCUS_SESSION_BY_USER_LOADED = 'ACTION_TRUFOCUS_SESSION_BY_USER_LOADED'

export const ACTION_GAME_RESULT_BY_USER_LOADING_ERROR = 'ACTION_GAME_RESULT_BY_USER_LOADING_ERROR'
export const ACTION_GAME_RESULT_BY_USER_LOADING = 'ACTION_GAME_RESULT_BY_USER_LOADING'
export const ACTION_GAME_RESULT_BY_USER_LOADED = 'ACTION_GAME_RESULT_BY_USER_LOADED'

export const ACTION_RESET_PASSWORD_ERROR = 'ACTION_RESET_PASSWORD_ERROR'
export const ACTION_RESET_PASSWORD_LOADING = 'ACTION_RESET_PASSWORD_LOADING'
export const ACTION_RESET_PASSWORD_LOADED = 'ACTION_RESET_PASSWORD_LOADED'

export const ACTION_REGISTRATION_ERROR = 'ACTION_REGISTRATION_ERROR'
export const ACTION_REGISTRATION_LOADING = 'ACTION_REGISTRATION_LOADING'
export const ACTION_REGISTRATION_LOADED = 'ACTION_REGISTRATION_LOADED'

export const ACTION_USER_INFO_ERROR = 'ACTION_USER_INFO_ERROR'
export const ACTION_USER_INFO_LOADING = 'ACTION_USER_INFO_LOADING'
export const ACTION_USER_INFO_LOADED = 'ACTION_USER_INFO_LOADED'

export const ACTION_UPDATE_USER_INFO_ERROR = 'ACTION_UPDATE_USER_INFO_ERROR'
export const ACTION_UPDATE_USER_INFO_LOADING = 'ACTION_UPDATE_USER_INFO_LOADING'
export const ACTION_UPDATE_USER_INFO_LOADED = 'ACTION_UPDATE_USER_INFO_LOADED'

export const ACTION_ENTERPRISE_USER_LIST_ERROR = 'ACTION_ENTERPRISE_USER_LIST_ERROR'
export const ACTION_ENTERPRISE_USER_LIST_LOADING = 'ACTION_ENTERPRISE_USER_LIST_LOADING'
export const ACTION_ENTERPRISE_USER_LIST_LOADED = 'ACTION_ENTERPRISE_USER_LIST_LOADED'

export const ACTION_ENTERPRISE_ACCOUNT_LIST_ERROR = 'ACTION_ENTERPRISE_ACCOUNT_LIST_ERROR'
export const ACTION_ENTERPRISE_ACCOUNT_LIST_LOADING = 'ACTION_ENTERPRISE_ACCOUNT_LIST_LOADING'
export const ACTION_ENTERPRISE_ACCOUNT_LIST_LOADED = 'ACTION_ENTERPRISE_ACCOUNT_LIST_LOADED'

export const ACTION_ENTERPRISE_ACCOUNT_CREATE_ERROR = 'ACTION_ENTERPRISE_ACCOUNT_CREATE_ERROR'
export const ACTION_ENTERPRISE_ACCOUNT_CREATE_LOADING = 'ACTION_ENTERPRISE_ACCOUNT_CREATE_LOADING'
export const ACTION_ENTERPRISE_ACCOUNT_CREATE_LOADED = 'ACTION_ENTERPRISE_ACCOUNT_CREATE_LOADED'

export const ACTION_ENTERPRISE_ACCOUNT_UPDATE_ERROR = 'ACTION_ENTERPRISE_ACCOUNT_UPDATE_ERROR'
export const ACTION_ENTERPRISE_ACCOUNT_UPDATE_LOADING = 'ACTION_ENTERPRISE_ACCOUNT_UPDATE_LOADING'
export const ACTION_ENTERPRISE_ACCOUNT_UPDATE_LOADED = 'ACTION_ENTERPRISE_ACCOUNT_UPDATE_LOADED'

export const ACTION_ENTERPRISE_ACCOUNT_SHOW_ERROR = 'ACTION_ENTERPRISE_ACCOUNT_SHOW_ERROR'
export const ACTION_ENTERPRISE_ACCOUNT_SHOW_LOADING = 'ACTION_ENTERPRISE_ACCOUNT_SHOW_LOADING'
export const ACTION_ENTERPRISE_ACCOUNT_SHOW_LOADED = 'ACTION_ENTERPRISE_ACCOUNT_SHOW_LOADED'

export const ACTION_QUERY_COUNTRY_LIST_ERROR = 'ACTION_QUERY_COUNTRY_LIST_ERROR'
export const ACTION_QUERY_COUNTRY_LIST_LOADING = 'ACTION_QUERY_COUNTRY_LIST_LOADING'
export const ACTION_QUERY_COUNTRY_LIST_LOADED = 'ACTION_QUERY_COUNTRY_LIST_LOADED'

export const ACTION_QUERY_EDUCATION_LIST_ERROR = 'ACTION_QUERY_EDUCATION_LIST_ERROR'
export const ACTION_QUERY_EDUCATION_LIST_LOADING = 'ACTION_QUERY_EDUCATION_LIST_LOADING'
export const ACTION_QUERY_EDUCATION_LIST_LOADED = 'ACTION_QUERY_EDUCATION_LIST_LOADED'

export const ACTION_QUERY_OCCUPATION_LIST_ERROR = 'ACTION_QUERY_OCCUPATION_LIST_ERROR'
export const ACTION_QUERY_OCCUPATION_LIST_LOADING = 'ACTION_QUERY_OCCUPATION_LIST_LOADING'
export const ACTION_QUERY_OCCUPATION_LIST_LOADED = 'ACTION_QUERY_OCCUPATION_LIST_LOADED'

export const ACTION_QUERY_USER_INFO_ERROR = 'ACTION_QUERY_USER_INFO_ERROR'
export const ACTION_QUERY_USER_INFO_LOADING = 'ACTION_QUERY_USER_INFO_LOADING'
export const ACTION_QUERY_USER_INFO_LOADED = 'ACTION_QUERY_USER_INFO_LOADED'

export const ACTION_UPDATE_CURRENT_USER_INFO_ERROR = 'ACTION_UPDATE_CURRENT_USER_INFO_ERROR'
export const ACTION_UPDATE_CURRENT_USER_INFO_LOADING = 'ACTION_UPDATE_CURRENT_USER_INFO_LOADING'
export const ACTION_UPDATE_CURRENT_USER_INFO_LOADED = 'ACTION_UPDATE_CURRENT_USER_INFO_LOADED'

export const ACTION_ARCHIVE_USER_DATA_ERROR = 'ACTION_ARCHIVE_USER_DATA_ERROR'
export const ACTION_ARCHIVE_USER_DATA_LOADING = 'ACTION_ARCHIVE_USER_DATA_LOADING'
export const ACTION_ARCHIVE_USER_DATA_LOADED = 'ACTION_ARCHIVE_USER_DATA_LOADED'

export const ACTION_QUERY_MY_ASSESSMENT_ERROR = 'ACTION_QUERY_MY_ASSESSMENT_ERROR'
export const ACTION_QUERY_MY_ASSESSMENT_LOADING = 'ACTION_QUERY_MY_ASSESSMENT_LOADING'
export const ACTION_QUERY_MY_ASSESSMENT_LOADED = 'ACTION_QUERY_MY_ASSESSMENT_LOADED'

export const ACTION_QUERY_ASSESSMENT_BY_USER_ERROR = 'ACTION_QUERY_ASSESSMENT_BY_USER_ERROR'
export const ACTION_QUERY_ASSESSMENT_BY_USER_LOADING = 'ACTION_QUERY_ASSESSMENT_BY_USER_LOADING'
export const ACTION_QUERY_ASSESSMENT_BY_USER_LOADED = 'ACTION_QUERY_ASSESSMENT_BY_USER_LOADED'

export const ACTION_QUERY_ANALYTICS_SCORE_ERROR = 'ACTION_QUERY_ANALYTICS_SCORE_ERROR'
export const ACTION_QUERY_ANALYTICS_SCORE_LOADING = 'ACTION_QUERY_ANALYTICS_SCORE_LOADING'
export const ACTION_QUERY_ANALYTICS_SCORE_LOADED = 'ACTION_QUERY_ANALYTICS_SCORE_LOADED'

export const ACTION_QUERY_ANALYTICS_SCORE_BY_USER_ERROR = 'ACTION_QUERY_ANALYTICS_SCORE_BY_USER_ERROR'
export const ACTION_QUERY_ANALYTICS_SCORE_BY_USER_LOADING = 'ACTION_QUERY_ANALYTICS_SCORE_BY_USER_LOADING'
export const ACTION_QUERY_ANALYTICS_SCORE_BY_USER_LOADED = 'ACTION_QUERY_ANALYTICS_SCORE_BY_USER_LOADED'

export const ACTION_QUERY_ACTIVE_TRAINING_RECORD_ERROR = 'ACTION_QUERY_ACTIVE_TRAINING_RECORD_ERROR'
export const ACTION_QUERY_ACTIVE_TRAINING_RECORD_LOADING = 'ACTION_QUERY_ACTIVE_TRAINING_RECORD_LOADING'
export const ACTION_QUERY_ACTIVE_TRAINING_RECORD_LOADED = 'ACTION_QUERY_ACTIVE_TRAINING_RECORD_LOADED'

export const ACTION_QUERY_USER_GROWTH_REPORT_ERROR = 'ACTION_QUERY_USER_GROWTH_REPORT_ERROR'
export const ACTION_QUERY_USER_GROWTH_REPORT_LOADING = 'ACTION_QUERY_USER_GROWTH_REPORT_LOADING'
export const ACTION_QUERY_USER_GROWTH_REPORT_LOADED = 'ACTION_QUERY_USER_GROWTH_REPORT_LOADED'

export const ACTION_QUERY_USER_USAGE_REPORT_ERROR = 'ACTION_QUERY_USER_USAGE_REPORT_ERROR'
export const ACTION_QUERY_USER_USAGE_REPORT_LOADING = 'ACTION_QUERY_USER_USAGE_REPORT_LOADING'
export const ACTION_QUERY_USER_USAGE_REPORT_LOADED = 'ACTION_QUERY_USER_USAGE_REPORT_LOADED'

export const ACTION_QUERY_USAGE_REPORT_ERROR = 'ACTION_QUERY_USAGE_REPORT_ERROR'
export const ACTION_QUERY_USAGE_REPORT_LOADING = 'ACTION_QUERY_USAGE_REPORT_LOADING'
export const ACTION_QUERY_USAGE_REPORT_LOADED = 'ACTION_QUERY_USAGE_REPORT_LOADED'

export const ACTION_QUERY_MY_USAGE_REPORT_ERROR = 'ACTION_QUERY_MY_USAGE_REPORT_ERROR'
export const ACTION_QUERY_MY_USAGE_REPORT_LOADING = 'ACTION_QUERY_MY_USAGE_REPORT_LOADING'
export const ACTION_QUERY_MY_USAGE_REPORT_LOADED = 'ACTION_QUERY_MY_USAGE_REPORT_LOADED'

export const ACTION_QUERY_USER_SCORE_BENCHMARK_ERROR = 'ACTION_QUERY_USER_SCORE_BENCHMARK_ERROR'
export const ACTION_QUERY_USER_SCORE_BENCHMARK_LOADING = 'ACTION_QUERY_USER_SCORE_BENCHMARK_LOADING'
export const ACTION_QUERY_USER_SCORE_BENCHMARK_LOADED = 'ACTION_QUERY_USER_SCORE_BENCHMARK_LOADED'


export const ACTION_SKIN_HMAC_ERROR = 'ACTION_SKIN_HMAC_ERROR'
export const ACTION_SKIN_HMAC_LOADING = 'ACTION_SKIN_HMAC_LOADING'
export const ACTION_SKIN_HMAC_LOADED = 'ACTION_SKIN_HMAC_LOADED'

export const ACTION_QUERY_TRAINING_RECORD_BY_USER_ERROR = 'ACTION_QUERY_TRAINING_RECORD_BY_USER_ERROR'
export const ACTION_QUERY_TRAINING_RECORD_BY_USER_LOADING = 'ACTION_QUERY_TRAINING_RECORD_BY_USER_LOADING'
export const ACTION_QUERY_TRAINING_RECORD_BY_USER_LOADED = 'ACTION_QUERY_TRAINING_RECORD_BY_USER_LOADED'

export const ACTION_MY_ALL_GAME_LATEST_SCORES_ERROR = 'ACTION_MY_ALL_GAME_LATEST_SCORES_ERROR'
export const ACTION_MY_ALL_GAME_LATEST_SCORES_LOADING = 'ACTION_MY_ALL_GAME_LATEST_SCORES_LOADING'
export const ACTION_MY_ALL_GAME_LATEST_SCORES_LOADED = 'ACTION_MY_ALL_GAME_LATEST_SCORES_LOADED'

export const ACTION_ASSESSMENT_PERFORMANCE_REPORT_ERROR = 'ACTION_ASSESSMENT_PERFORMANCE_REPORT_ERROR'
export const ACTION_ASSESSMENT_PERFORMANCE_REPORT_LOADING = 'ACTION_ASSESSMENT_PERFORMANCE_REPORT_LOADING'
export const ACTION_ASSESSMENT_PERFORMANCE_REPORT_LOADED = 'ACTION_ASSESSMENT_PERFORMANCE_REPORT_LOADED'

export const ACTION_MY_ASSESSMENT_PERFORMANCE_REPORT_ERROR = 'ACTION_MY_ASSESSMENT_PERFORMANCE_REPORT_ERROR'
export const ACTION_MY_ASSESSMENT_PERFORMANCE_REPORT_LOADING = 'ACTION_MY_ASSESSMENT_PERFORMANCE_REPORT_LOADING'
export const ACTION_MY_ASSESSMENT_PERFORMANCE_REPORT_LOADED = 'ACTION_MY_ASSESSMENT_PERFORMANCE_REPORT_LOADED'

export const ACTION_COGNITIVE_PERFORMANCE_REPORT_ERROR = 'ACTION_COGNITIVE_PERFORMANCE_REPORT_ERROR'
export const ACTION_COGNITIVE_PERFORMANCE_REPORT_LOADING = 'ACTION_COGNITIVE_PERFORMANCE_REPORT_LOADING'
export const ACTION_COGNITIVE_PERFORMANCE_REPORT_LOADED = 'ACTION_COGNITIVE_PERFORMANCE_REPORT_LOADED'

export const ACTION_GAME_PERFORMANCE_REPORT_ERROR = 'ACTION_GAME_PERFORMANCE_REPORT_ERROR'
export const ACTION_GAME_PERFORMANCE_REPORT_LOADING = 'ACTION_GAME_PERFORMANCE_REPORT_LOADING'
export const ACTION_GAME_PERFORMANCE_REPORT_LOADED = 'ACTION_GAME_PERFORMANCE_REPORT_LOADED'

export const ACTION_ALL_GAME_PERFORMANCE_REPORT_ERROR = 'ACTION_ALL_GAME_PERFORMANCE_REPORT_ERROR'
export const ACTION_ALL_GAME_PERFORMANCE_REPORT_LOADING = 'ACTION_ALL_GAME_PERFORMANCE_REPORT_LOADING'
export const ACTION_ALL_GAME_PERFORMANCE_REPORT_LOADED = 'ACTION_ALL_GAME_PERFORMANCE_REPORT_LOADED'

export const ACTION_MY_GAME_PERFORMANCE_REPORT_ERROR = 'ACTION_MY_GAME_PERFORMANCE_REPORT_ERROR'
export const ACTION_MY_GAME_PERFORMANCE_REPORT_LOADING = 'ACTION_MY_GAME_PERFORMANCE_REPORT_LOADING'
export const ACTION_MY_GAME_PERFORMANCE_REPORT_LOADED = 'ACTION_MY_GAME_PERFORMANCE_REPORT_LOADED'


export const ACTION_ACTIVE_USER_REPORT_ERROR = 'ACTION_ACTIVE_USER_REPORT_ERROR'
export const ACTION_ACTIVE_USER_REPORT_LOADING = 'ACTION_ACTIVE_USER_REPORT_LOADING'
export const ACTION_ACTIVE_USER_REPORT_LOADED = 'ACTION_ACTIVE_USER_REPORT_LOADED'

export const ACTION_INACTIVE_USER_REPORT_ERROR = 'ACTION_INACTIVE_USER_REPORT_ERROR'
export const ACTION_INACTIVE_USER_REPORT_LOADING = 'ACTION_INACTIVE_USER_REPORT_LOADING'
export const ACTION_INACTIVE_USER_REPORT_LOADED = 'ACTION_INACTIVE_USER_REPORT_LOADED'

export const ACTION_AUTHORIZATION_INVITATIONS_ERROR = 'ACTION_AUTHORIZATION_INVITATIONS_ERROR'
export const ACTION_AUTHORIZATION_INVITATIONS_LOADING = 'ACTION_AUTHORIZATION_INVITATIONS_LOADING'
export const ACTION_AUTHORIZATION_INVITATIONS_LOADED = 'ACTION_AUTHORIZATION_INVITATIONS_LOADED'

export const ACTION_AUTHORIZATION_INVITATION_RESULTS_ERROR = 'ACTION_AUTHORIZATION_INVITATION_RESULTS_ERROR'
export const ACTION_AUTHORIZATION_INVITATION_RESULTS_LOADING = 'ACTION_AUTHORIZATION_INVITATION_RESULTS_LOADING'
export const ACTION_AUTHORIZATION_INVITATION_RESULTS_LOADED = 'ACTION_AUTHORIZATION_INVITATION_RESULTS_LOADED'

export const ACTION_QUERY_ADMIN_USERS_LOADING = 'ACTION_QUERY_ADMIN_USERS_LOADING'
export const ACTION_QUERY_ADMIN_USERS_LOADED = 'ACTION_QUERY_ADMIN_USERS_LOADED'
export const ACTION_QUERY_ADMIN_USERS_ERROR = 'ACTION_QUERY_ADMIN_USERS_ERROR'

export const ACTION_QUERY_TINELINE_EVENT_LOADING = 'ACTION_QUERY_TINELINE_EVENT_LOADING'
export const ACTION_QUERY_TINELINE_EVENT_LOADED = 'ACTION_QUERY_TINELINE_EVENT_LOADED'
export const ACTION_QUERY_TINELINE_EVENT_ERROR = 'ACTION_QUERY_TINELINE_EVENT_ERROR'

export const ACTION_QUERY_LICENSES_LOADING = 'ACTION_QUERY_LICENSES_LOADING'
export const ACTION_QUERY_LICENSES_LOADED = 'ACTION_QUERY_LICENSES_LOADED'
export const ACTION_QUERY_LICENSES_ERROR = 'ACTION_QUERY_LICENSES_ERROR'

export const ACTION_QUERY_LICENSE_TYPES_LOADING = 'ACTION_QUERY_LICENSE_TYPES_LOADING'
export const ACTION_QUERY_LICENSE_TYPES_LOADED = 'ACTION_QUERY_LICENSE_TYPES_LOADED'
export const ACTION_QUERY_LICENSE_TYPES_ERROR = 'ACTION_QUERY_LICENSE_TYPES_ERROR'

export const ACTION_QUERY_APPLICATIONS_LOADING = 'ACTION_QUERY_APPLICATIONS_LOADING'
export const ACTION_QUERY_APPLICATIONS_LOADED = 'ACTION_QUERY_APPLICATIONS_LOADED'
export const ACTION_QUERY_APPLICATIONS_ERROR = 'ACTION_QUERY_APPLICATIONS_ERROR'

export const ACTION_SHOW_LICENSE_LOADING = 'ACTION_SHOW_LICENSE_LOADING'
export const ACTION_SHOW_LICENSE_LOADED = 'ACTION_SHOW_LICENSE_LOADED'
export const ACTION_SHOW_LICENSE_ERROR = 'ACTION_SHOW_LICENSE_ERROR'

export const ACTION_UPDATE_LICENSE_LOADING = 'ACTION_UPDATE_LICENSE_LOADING'
export const ACTION_UPDATE_LICENSE_LOADED = 'ACTION_UPDATE_LICENSE_LOADED'
export const ACTION_UPDATE_LICENSE_ERROR = 'ACTION_UPDATE_LICENSE_ERROR'

export const ACTION_CREATE_LICENSE_LOADING = 'ACTION_CREATE_LICENSE_LOADING'
export const ACTION_CREATE_LICENSE_LOADED = 'ACTION_CREATE_LICENSE_LOADED'
export const ACTION_CREATE_LICENSE_ERROR = 'ACTION_CREATE_LICENSE_ERROR'

export const ACTION_DELETE_LICENSE_LOADING = 'ACTION_DELETE_LICENSE_LOADING'
export const ACTION_DELETE_LICENSE_LOADED = 'ACTION_DELETE_LICENSE_LOADED'
export const ACTION_DELETE_LICENSE_ERROR = 'ACTION_DELETE_LICENSE_ERROR'

export const ACTION_UNLOCK_ALL_LEVELS_LOADING = 'ACTION_UNLOCK_ALL_LEVELS_LOADING'
export const ACTION_UNLOCK_ALL_LEVELS_LOADED = 'ACTION_UNLOCK_ALL_LEVELS_LOADED'
export const ACTION_UNLOCK_ALL_LEVELS_ERROR = 'ACTION_UNLOCK_ALL_LEVELS_ERROR'

export const ACTION_ENTERPRISE_ACCOUNT_ADD_USER_LOADING = 'ACTION_ENTERPRISE_ACCOUNT_ADD_USER_LOADING'
export const ACTION_ENTERPRISE_ACCOUNT_ADD_USER_LOADED = 'ACTION_ENTERPRISE_ACCOUNT_ADD_USER_LOADED'
export const ACTION_ENTERPRISE_ACCOUNT_ADD_USER_ERROR = 'ACTION_ENTERPRISE_ACCOUNT_ADD_USER_ERROR'

export const ACTION_ENTERPRISE_ACCOUNT_ADD_USER_BATCH_LOADING = 'ACTION_ENTERPRISE_ACCOUNT_ADD_USER_BATCH_LOADING'
export const ACTION_ENTERPRISE_ACCOUNT_ADD_USER_BATCH_LOADED = 'ACTION_ENTERPRISE_ACCOUNT_ADD_USER_BATCH_LOADED'
export const ACTION_ENTERPRISE_ACCOUNT_ADD_USER_BATCH_ERROR = 'ACTION_ENTERPRISE_ACCOUNT_ADD_USER_BATCH_ERROR'

export const ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_LOADING = 'ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_LOADING'
export const ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_LOADED = 'ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_LOADED'
export const ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_ERROR = 'ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_ERROR'

export const ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_BATCH_LOADING = 'ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_BATCH_LOADING'
export const ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_BATCH_LOADED = 'ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_BATCH_LOADED'
export const ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_BATCH_ERROR = 'ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_BATCH_ERROR'

export const ACTION_UPDATE_NAVBAR_ITEMS = 'ACTION_UPDATE_NAVBAR_ITEMS'

export const ACTION_SET_CURRENT_ENTERPRISE_ACCOUNT = 'ACTION_SET_CURRENT_ENTERPRISE_ACCOUNT'
export const ACTION_SET_CURRENT_APPLICATION = 'ACTION_SET_CURRENT_APPLICATION'

export const ACTION_COMMENT_USER_LOADING = 'ACTION_COMMENT_USER_LOADING'
export const ACTION_COMMENT_USER_LOADED = 'ACTION_COMMENT_USER_LOADED'
export const ACTION_COMMENT_USER_ERROR = 'ACTION_COMMENT_USER_ERROR'

export const ACTION_GET_USER_COMMENTS_LOADING = 'ACTION_GET_USER_COMMENTS_LOADING'
export const ACTION_GET_USER_COMMENTS_LOADED = 'ACTION_GET_USER_COMMENTS_LOADED'
export const ACTION_GET_USER_COMMENTS_ERROR = 'ACTION_GET_USER_COMMENTS_ERROR'

export const ACTION_COGOLAND_USERS_WITH_STATUS_LOADING = 'ACTION_COGOLAND_USERS_WITH_STATUS_LOADING'
export const ACTION_COGOLAND_USERS_WITH_STATUS_LOADED = 'ACTION_COGOLAND_USERS_WITH_STATUS_LOADED'
export const ACTION_COGOLAND_USERS_WITH_STATUS_ERROR = 'ACTION_COGOLAND_USERS_WITH_STATUS_ERROR'

export const ACTION_COGOLAND_GET_SCHEDULE_BY_USER_LOADING = 'ACTION_COGOLAND_GET_SCHEDULE_BY_USER_LOADING'
export const ACTION_COGOLAND_GET_SCHEDULE_BY_USER_LOADED = 'ACTION_COGOLAND_GET_SCHEDULE_BY_USER_LOADED'
export const ACTION_COGOLAND_GET_SCHEDULE_BY_USER_ERROR = 'ACTION_COGOLAND_GET_SCHEDULE_BY_USER_ERROR'

export const ACTION_COGOLAND_CREATE_SCHEDULE_FOR_USER_LOADING = 'ACTION_COGOLAND_CREATE_SCHEDULE_FOR_USER_LOADING'
export const ACTION_COGOLAND_CREATE_SCHEDULE_FOR_USER_LOADED = 'ACTION_COGOLAND_CREATE_SCHEDULE_FOR_USER_LOADED'
export const ACTION_COGOLAND_CREATE_SCHEDULE_FOR_USER_ERROR = 'ACTION_COGOLAND_CREATE_SCHEDULE_FOR_USER_ERROR'

export const ACTION_COGOLAND_PREVIEW_SCHEDULE_LOADING = 'ACTION_COGOLAND_PREVIEW_SCHEDULE_LOADING'
export const ACTION_COGOLAND_PREVIEW_SCHEDULE_LOADED = 'ACTION_COGOLAND_PREVIEW_SCHEDULE_LOADED'
export const ACTION_COGOLAND_PREVIEW_SCHEDULE_ERROR = 'ACTION_COGOLAND_PREVIEW_SCHEDULE_ERROR'

export const ACTION_COGOLAND_RESCHEDULE_SESSION_LOADING = 'ACTION_COGOLAND_RESCHEDULE_SESSION_LOADING'
export const ACTION_COGOLAND_RESCHEDULE_SESSION_LOADED = 'ACTION_COGOLAND_RESCHEDULE_SESSION_LOADED'
export const ACTION_COGOLAND_RESCHEDULE_SESSION_ERROR = 'ACTION_COGOLAND_RESCHEDULE_SESSION_ERROR'





export const PATH_LOGIN = '/api/login'
export const PATH_USER = '/api/users'
export const PATH_COGOLAND_RESCHEDULE_SESSION = '/api/cogoLand/rescheduleSession'
export const PATH_UNLOCK_ALL_LEVELS = '/api/common/unlockAllLevels'
export const PATH_APPLICATIONS = '/api/applications'
export const PATH_ADMIN_USERS = '/api/common/adminUsers'
export const PATH_RESEND_USER_EMAIL_ADDRESS_CONFIRMATION = '/api/user/sendEmailAddressConfirmation'
export const PATH_QUERY_SURVEY = '/registration/survey'
export const PATH_SAVE_SURVEY = '/api/survey/saveSurvey'
export const PATH_SAVE_SURVEY_ANSWER = '/registration/saveSurveyAnswer'
export const PATH_SHOW_SURVEY_ANSWER = '/registration/showSurveyAnswer'
export const PATH_LIST_SURVEY_ANSWER = '/registration/listSurveyAnswer'
export const PATH_ENTERPRISE_USER_LIST = '/api/enterprise/{enterpriseAccountId}/users'
export const PATH_AUTHORIZATION_INVITATION_LIST = '/api/enterprise/{accountId}/invitations'
export const PATH_SEND_INVITATIONS = '/api/authorizationInvitation/invite'
export const PATH_ENTERPRISE_ACCOUNTS = '/api/enterpriseAccounts'
export const PATH_ENTERPRISE_ACCOUNTS_V2 = '/api/v2/enterpriseAccounts'
export const PATH_RESET_PASSWORD = '/registration/resetPassword'
export const PATH_REGISTRATION = '/registration'
export const PATH_SKIN_HMAC = '/api/payment/skinHmac/{system}'
export const PATH_QUERY_COUNTRIES = '/registration/countries'
export const PATH_QUERY_EDUCATIONS = '/registration/educations'
export const PATH_QUERY_OCCUPATIONS = '/registration/occupations'
export const PATH_USER_INFO = '/api/common/getCurrentUserInfo'
export const PATH_MY_ALL_GAME_LATEST_SCORES = '/api/common/myAllGameLatestScores'
export const PATH_USER_GROWTH_REPORT = '/api/user/growthReport'
export const PATH_USER_USAGE_REPORT = '/api/user/usageReport'
export const PATH_USAGE_REPORT = '/api/gameResult/usageReport'
export const PATH_MY_USAGE_REPORT = '/api/gameResult/myUsageReport'
export const PATH_COGNITIVE_PERFORMANCE_REPORT = '/api/gameResult/performanceReport'
export const PATH_GAME_PERFORMANCE_REPORT = '/api/gameResult/gamePerformanceReport'
export const PATH_ALL_GAME_PERFORMANCE_REPORT = '/api/gameResult/allGamePerformanceReport'
export const PATH_MY_GAME_PERFORMANCE_REPORT = '/api/gameResult/myGamePerformanceReport'
export const PATH_ASSESSMENT_PERFORMANCE_REPORT = '/api/assessmentRecord/performanceReport'
export const PATH_MY_ASSESSMENT_PERFORMANCE_REPORT = '/api/assessmentRecord/myPerformanceReport'
export const PATH_ACTIVE_USER_REPORT = '/api/user/activeUserReport'
export const PATH_INACTIVE_USER_REPORT = '/api/user/inactiveUserReport'
export const PATH_UPDATE_USER_INFO = '/api/common/updateUserInfo'
export const PATH_QUERY_GAME_RESULTS = '/api/common/queryGameResults'
export const PATH_QUERY_ANALYTICS_SCORE = '/api/common/queryAnalyticsScore'
export const PATH_QUERY_ANALYTICS_SCORE_BY_USER = '/api/user/{userId}/analyticsScore'
export const PATH_QUERY_GAME_RESULT_AGGREGATION = '/api/common/queryGameResultAggregation'
export const PATH_QUERY_GAME_RESULT_AGGREGATION_BY_USER = '/api/user/{userId}/gameResultAggregations'
export const PATH_QUERY_GAME_RESULTS_BY_USER = '/api/user/{userId}/gameResults'
export const PATH_ARCHIVE_USER_DATA = '/api/user/{userId}/archive'
export const PATH_QUERY_MY_ASSESSMENTS = '/api/myAssessmentRecords'
export const PATH_QUERY_ASSESSMENTS_BY_USER = '/api/user/{userId}/assessments'
export const PATH_QUERY_ACTIVE_TRAINING_RECORDS = '/api/myActiveTrainingRecords'
export const PATH_QUERY_TRAINING_RECORDS_BY_USER = '/api/user/{userId}/trainingRecords'
export const PATH_USER_IMAGE_UPLOAD = '/api/user/profileImage/{fileExtension}'
export const PATH_USER_IMAGE_UPLOAD_BY_ID = '/api/users/{userId}/profileImage/{fileExtension}'
export const PATH_ENTERPRISE_LOGO_UPLOAD = '/api/enterprise/{enterpriseAccountId}/logo/{fileExtension}'
export const PATH_USER_SCORE_BENCHMARK = '/api/user/scoreBenchmark/{scoreName}/{scoreValue}'
export const PATH_USER_SEARCH = '/api/user/search'
export const PATH_ENTERPRISE_ACCOUNT_ADD_USER = '/api/common/createEnterpriseUser'
export const PATH_ENTERPRISE_ACCOUNT_ADD_USER_BATCH = '/api/common/createEnterpriseUserBatch'
export const PATH_QUERY_TIMELINE_EVENT = '/api/common/queryTimelineEvents'
export const PATH_ENTERPRISE_ACCOUNT_USER_REPORT = '/api/common/enterpriseUserReport'
export const PATH_ENTERPRISE_ACCOUNT_USER_REPORT_BATCH = '/api/common/batchUserReportGeneration'
export const PATH_ENTERPRISE_ACCOUNT_USER_REPORT_SINGLE = '/api/common/userReportGeneration'
export const PATH_TRUFOCUS_SESSION = '/api/trufocus/querySessions'
export const PATH_TRUFOCUS_SESSION_BY_USER = '/api/user/{userId}/trufocus/sessions'

export const PATH_COGOLAND_USERS_WITH_STATUS = '/api/cogoLand/users'
export const PATH_COGOLAND_SCHEDULE_BY_USER = '/api/cogoLand/getScheduleByUser'
export const PATH_COGOLAND_CREATE_SCHEDULE_FOR_USER = '/api/cogoLand/createScheduleForUser'
export const PATH_COGOLAND_PREVIEW_SCHEDULE = '/api/cogoLand/previewSchedule'

export const PATH_LICENSE_TYPES = '/api/licenseTypes'
export const PATH_LICENSES = '/api/licenses'

export const PATH_GET_USER_COMMENTS = '/api/user/getComments'
export const PATH_COMMENT_USER = '/api/user/commentUser'

export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const DATE_DISPLAY_FORMAT = 'DD-MMM-YYYY'
export const REPORT_DATE_DISPLAY_FORMAT = 'DD MMM YYYY'
export const DATE_CHART_FORMAT = 'YYYY-MM-DD'
export const COGOLAND_SESSION_DATE_FORMAT = 'l (ddd)'
export const COGOLAND_SESSION_DATE_TIME_FORMAT = 'l (ddd) LTS'

export const hexToRGB = function(hex){
  hex = parseInt(hex.substring(1), 16)
  var r = hex >> 16;
  var g = hex >> 8 & 0xFF;
  var b = hex & 0xFF;
  return [r,g,b].join(',');
}

export const SAP_COLOR_LIST = ['#5cbae6', '#93b9c6', '#ccc5a8', '#98aafb', '#8cd3ff']
export const SAP_RGBA_COLOR_LIST = SAP_COLOR_LIST.map((c)=>hexToRGB(c))

export const COLOR_ADMIN_COMPONENTS = '#4e92df'

export const COLOR_WITH_SENZEBAND = '#60bae4'
export const COLOR_WITHOUT_SENZEBAND = '#3942cc'

export const COLOR_GRAY = '#F3F3F3'
export const COLOR_NAVY = '#931D4D'
export const COLOR_ATTENTION = '#ffc336'
export const COLOR_MEMORY = '#0fbedd'
export const COLOR_SPACIAL = '#f66d92'
export const COLOR_DECISION = '#3b87a2'
export const COLOR_FLEXIBILITY = '#72b737'

export const COLOR_VERY_NEGATIVE = '#E4210D'
export const COLOR_NEGATIVE = '#F8A322'
export const COLOR_NEUTRAL = '#666666'
export const COLOR_POSITIVE = '#14813C'
export const COLOR_VERY_POSITIVE = '#28CD91'

export const COLOR_ATTENTIVE = '#399750'
export const COLOR_FLUCUATING = '#00de54'
export const COLOR_IMPUSIVE = '#feff55'
export const COLOR_DISTRACTED = '#ffc336'
export const COLOR_DISENGAGED = '#ff464a'

export const RGBA_COLOR_ATTENTIVE = hexToRGB(COLOR_ATTENTIVE)
export const RGBA_COLOR_FLUCUATING = hexToRGB(COLOR_FLUCUATING)
export const RGBA_COLOR_IMPUSIVE = hexToRGB(COLOR_IMPUSIVE)
export const RGBA_COLOR_DISTRACTED = hexToRGB(COLOR_DISTRACTED)
export const RGBA_COLOR_DISENGAGED = hexToRGB(COLOR_DISENGAGED)

export const COLOR_REPORT_POSITIVE = '#45BF6C'
export const COLOR_REPORT_NEGATIVE = '#CD5373'

export const convertOrder = (order)=>{
  if(order === 'asc') return 'up'
  else if(order === 'desc') return 'down'
  else return order
}

export const SCORE_CATEGORY_COLOR_MAP = {

  'minimal': '#E4210D',
  'basic': '#F19304',
  'balanced': '#0C6187',
  'effective': '#4A94F5',
  'optimal': '#71CF36'
}

export const RGBA_COLOR_NEEURO = '160,0,76'
export const RGBA_COLOR_NAVY = '58,166,130'
export const RGBA_COLOR_LAZUR = '63,188,188'
export const RGBA_COLOR_GRAY = '220,220,220'
export const RGBA_COLOR_CHART = SAP_RGBA_COLOR_LIST[0]

export const RGBA_COLOR_VERY_NEGATIVE = '228,33,13'
export const RGBA_COLOR_NEGATIVE = '248,163,34'
export const RGBA_COLOR_NEUTRAL = '102,102,102'
export const RGBA_COLOR_POSITIVE = '20,129,60'
export const RGBA_COLOR_VERY_POSITIVE = '40,205,145'

export const SCORE_CATEGORY_RGBA_COLOR_MAP = {

  'minimal': RGBA_COLOR_DISENGAGED,
  'basic': RGBA_COLOR_DISTRACTED,
  'balanced': RGBA_COLOR_IMPUSIVE,
  'effective': RGBA_COLOR_FLUCUATING,
  'optimal': RGBA_COLOR_ATTENTIVE
}

/*export const SCORE_CATEGORY_RGBA_COLOR_MAP_COGOLAND = {

  'minimal': hexToRGB('#ff9495'),
  'basic': hexToRGB('#ffc3a0'),
  'balanced': hexToRGB('#f2f4a9'),
  'effective': hexToRGB('#c6e5a0'),
  'optimal': hexToRGB('#94d09e'),
}*/

export const COLOR_EXEMPLARY = "#F3F3F3"
export const COLOR_PROGRESSIVE = "#E4E4E4"
export const SCORE_CATEGORY_RGBA_COLOR_MAP_COGOLAND = {

  'minimal': hexToRGB('#ea5745'),
  'basic': hexToRGB('#f39452'),
  'balanced': hexToRGB('#fac634'),
  'effective': hexToRGB('#b2cd4c'),
  'optimal': hexToRGB('#5aad53'),
  'exemplary': hexToRGB(COLOR_EXEMPLARY),
  'progressive': hexToRGB(COLOR_PROGRESSIVE),
}

export const RGBA_COLOR_PLATTE_2615 = ['57,19,26', '114,19,37', '192,32,67', '23,36,59', '17,14,24']
export const COLOR_PLATTE_2615 = ['#39131A', '#721325', '#C02043', '#17243B', '#110E18']


export const COLOR_LIST = SAP_RGBA_COLOR_LIST//[RGBA_COLOR_NEEURO, ...RGBA_COLOR_PLATTE_2615]

export const SENTIMENT_RBGA_COLOR_LIST = [RGBA_COLOR_VERY_NEGATIVE, RGBA_COLOR_NEGATIVE, RGBA_COLOR_NEUTRAL, RGBA_COLOR_POSITIVE, RGBA_COLOR_VERY_POSITIVE]
export const SENTIMENT_COLOR_LIST = [COLOR_VERY_NEGATIVE, COLOR_NEGATIVE, COLOR_NEUTRAL, COLOR_POSITIVE, COLOR_VERY_POSITIVE]

export const RGBA_COLOR_PAID_USER = COLOR_LIST[0]
export const RGBA_COLOR_BASIC_USER = COLOR_LIST[1]
export const RGBA_COLOR_ALL_USER = RGBA_COLOR_GRAY

export const ROLE_ADMIN = 'ROLE_ADMIN'
export const ROLE_OPS = 'ROLE_OPS'
export const ROLE_ENTERPRISE = 'ROLE_ENTERPRISE'

export const API_KEY_WEBPORTAL = 'c4998ec6-6d05-4ef1-b9ce-07097583dbc7'

export const ORDER_GAME_RESULT_SCORE = ["attention", "decision", "memory", "multitasking", "spatial"]
export const ORDER_ASSESSMENT_SCORE = ["attention", "memory", "spatial", "decisionFlexibility"]
export const SCORE_CATEGORIES = ['minimal', 'basic', 'balanced', 'effective', 'optimal']

export const getGameLabels = (game)=>{
  return ["attention", "decision", "memory", "multiTask", "spatial"].filter((l)=>game[l])
}

export const getCategory = (value)=>{
  let index = 0
  if(value > 100)
    index = 4
  else if(value <= 0)
    index = 0
  else
    index = Math.floor((value-1)/20)

  return ['minimal', 'basic', 'balanced', 'effective', 'optimal'][index]
}

export const AGE_GROUPS = ['3-4', '5-6', '7-12', '13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '65-999']

export const CHART_MAX_HEIGHT = 300

export const CHART_COLOR = COLOR_LIST[0]
export const chartConfigBuilder = (color, backgroundAlpha = 0.7, borderAlpha = 1, borderWidth = 3)=> ({
  backgroundColor: `rgba(${color},${backgroundAlpha})`,
  borderColor: `rgba(${color},${borderAlpha})`,
  pointBackgroundColor: `rgba(${color},1)`,
  pointBorderColor: `rgba(${color},1)`,
  borderWidth: borderWidth
})

export const chartConfigBuilderWithArray = (colors, backgroundAlpha = 0.7, borderAlpha = 1, borderWidth = 3)=> ({
  backgroundColor: colors.map(color=>`rgba(${color},${backgroundAlpha})`),
  borderColor: colors.map(color=>`rgba(${color},${borderAlpha})`),
  pointBackgroundColor: colors.map(color=>`rgba(${color},1)`),
  pointBorderColor: colors.map(color=>`rgba(${color},1)`),
  borderWidth: borderWidth
})

export const sentimentColorDatasetsConfig = {
  backgroundColor: SENTIMENT_RBGA_COLOR_LIST.map(c=>`rgba(${c},0.7)`),
  borderColor: SENTIMENT_RBGA_COLOR_LIST.map(c=>`rgba(${c},1)`),
  pointBackgroundColor: SENTIMENT_RBGA_COLOR_LIST.map(c=>`rgba(${c},1)`),
  pointBorderColor: "#fff",
  borderWidth: 2
}

export const CHART_CONFIG_BAR = chartConfigBuilder(CHART_COLOR)

export const INPUT_STYLE_ELEMENT_ONLY = {
  labelClassName: [{'col-sm-3': false}, 'hidden'],
  elementWrapperClassName: [{'col-sm-9': false}, 'col-sm-12']
}

export const buildChartOptions = (options, data)=>{

  const max = Math.max(...(data.datasets.map((it)=>Math.max(...it.data))))

  const xAxes = [{
    ticks: {
      fontSize: 10,
    }
  }]
  let modification = max < 10 && max > -10?{
    scales: {
      yAxes: [{
        ticks: {
          stepSize: 1,
          min: 0
        }
      }],
      xAxes: xAxes
    }
  }:{
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }],
        xAxes: xAxes
      }
    }

  const result = Object.assign({
    maintainAspectRatio: false
  }, options, modification)
  return result

}

export const KEY_MONTHLY_REPORT = 'monthlyReport'
export const KEY_ONE_DAY_REPORT = 'oneDayReport'
export const KEY_SEVEN_DAY_REPORT = 'sevenDayReport'
export const KEY_14_DAY_REPORT = '14DayReport'
export const KEY_21_DAY_REPORT = '21DayReport'

export const DEFAULT_CHART_LABELS_CONFIG = {
  usePointStyle: true,
  boxWidth: 12,
  generateLabels: (chart)=>{
    const labels = Chart.defaults.global.legend.labels.generateLabels(chart);
    labels.forEach((it)=>{
      it.fillStyle = it.strokeStyle
    })
    return labels;
  }
}

export const formatTruFocusLevel = (level, intl)=>level?intl.formatMessage({id:`trufocus.level.${level}`, defaultMessage:''}):''

export const getGender = (isMale, intl)=>{
  const unknown = intl.formatMessage({id:'unknown', defaultMessage:'Unknown'})
  const male = intl.formatMessage({id:'male', defaultMessage:'Male'})
  const female = intl.formatMessage({id:'female', defaultMessage:'Female'})

  return ` ${_.isNil(isMale) ? unknown : (isMale ?  male: female)}`
}

export const dayWeekMonthButtonGroupOptions = [
  {value: 'day', label: 'Day'},
  {value: 'week', label: 'Week'},
  {value: 'month', label: 'Month'}
]

export const buildCsvContent = (content)=>{
  let result = 'data:text/csv;charset=utf-8,'
  return encodeURI(result + content)
}

export const effectiveApplications = (license)=>{
  return license.applications&&license.applications.length>0?license.applications:license.application?[license.application]:[]
}

export const getLicenseFromApplicationName = (user, applicationName)=>{

  return _.find(user.currentEnterpriseAccount.licenses, (l) => {
    const applications = effectiveApplications(l)
    return _.find(applications, {name: applicationName})
  })

}

export const getCurrentLicense = (user, setCurrentApplication) => {

  if(user.currentApplication){

    return _.find(user.currentEnterpriseAccount.licenses, (l) => {
      const applications = effectiveApplications(l)
      return _.find(applications, {id: user.currentApplication.id})
    })
  }else{
    const license = user.currentEnterpriseAccount.licenses[0]
    const applications = effectiveApplications(license)
    if(applications.length > 0)
      setCurrentApplication(applications[0])
    return license
  }


}

export const getAvailableApplications = (user) => {

  const applicationMap = {}
  const licenses = op.get(user, 'currentEnterpriseAccount.licenses', [])
  licenses.forEach(l=>{
    const applications = effectiveApplications(l)
    applications.forEach(a=>{
      applicationMap[a.id] = a
    })
  })
  return _.values(applicationMap)

}

export const getCurrentApplication = (enterpriseAccount) => {

  const license = enterpriseAccount.licenses && enterpriseAccount.licenses.length > 0? enterpriseAccount.licenses[0]:null

  if(license && effectiveApplications(license).length > 0){
    const applications = effectiveApplications(license)
    const memorieApplication = _.find(applications, (app)=>(app.name === 'memorie'))
    if(memorieApplication) return memorieApplication
    else return applications[0]

  } else return null
}

export const avgBy = (array, iteratee)=>!_.isNil(array)&&!_.isEmpty(array)?_.sumBy(array,iteratee)/array.length:0

export const containsIgnoreCase = (s, q) => s ? s.toLowerCase().indexOf(q.toLowerCase()) > -1 : false

export const APPLICATION_DISPLAY_NAME = {
  memorie: 'Memorie',
  smarty: 'Smarty Knight',
  galini: 'Galini',
  trufocus: 'TruFocus',
}

export const omitByIsNil = obj => _.omitBy(obj, p=>{return _.isNil(p) || _.isNaN(p)})

export const value2color = (v)=>SCORE_CATEGORY_RGBA_COLOR_MAP[getCategory(v)]

export const calibrationStatusMap = {
  NONE: '-',
  PROCESSING: 'Processing',
  DONE: 'Done',
}

export const COGOLAND_ACTIVITY_TYPE_DESC = {
  CALIBRATION: 'Calibration',
  PREPARATION: 'Preparation',
  GAME_LEVEL_1: 'Basic',
  GAME_LEVEL_2: 'Intermediate',
  GAME_LEVEL_3: 'Advanced',
  MCQ_ENGLISH: 'Quiz',
  MCQ_MATH: 'Quiz',
  PVT: 'PVT'
}


export const ENTERPRISE_ACCOUNT_SUBTYPE_NONE = 'NONE'
export const ENTERPRISE_ACCOUNT_SUBTYPE_COGO_PVT = 'COGO_PVT'

export const ENTERPRISE_ACCOUNT_SUBTYPE_DESC = {
  COGO_PVT: "PVT"
}

export const COGO_TRAINING_NO_OF_CYCLES_PER_SESSION = 24

export const convertSessionIndexToX = (sessionIndex) => {
  return sessionIndex % COGO_TRAINING_NO_OF_CYCLES_PER_SESSION === 0 ?
    COGO_TRAINING_NO_OF_CYCLES_PER_SESSION
    :
    sessionIndex % COGO_TRAINING_NO_OF_CYCLES_PER_SESSION
}

export const getCurrentYear = ()=>{
  return moment().format("YYYY")
}



// WEBPACK FOOTER //
// ./src/constants.js